import { Directive } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl } from '@angular/forms';
import { phoneNumberValidator } from '../validatorFunctions';

@Directive({
  selector: '[gtPhoneNumberValidator]',
  providers: [{provide: NG_VALIDATORS, useExisting: PhoneNumberValidatorDirective, multi: true}]
})
export class PhoneNumberValidatorDirective implements Validator {

  validate(control: AbstractControl): {[key: string]: any} | null {
    return phoneNumberValidator()(control);
  }

}
